import React, { useEffect } from "react";
import { Trans } from "react-i18next";
import Modal from "react-modal";

function PopupModel(props) {
  return (
    <div>
      <Modal isOpen={props.isOpen} style={props.style} role="">
        <div style={{ textAlign: "center" }}>
          <label>{props.modelContent}</label>
          <button
            type={props.buttonType}
            className={props.buttonStyle}
            onClick={props.onClick}
          >
            {props.buttonLabel}
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default PopupModel;
